module.exports = __webpack_public_path__ + "@/assets/img/notification2.91ccd1e8.svg";